// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__ZH++5","bubble":"Tooltip_bubble__PwBwE"};